import React from 'react';
import { useI18n } from '../context/I18nContext';
import { MessageCircle } from 'lucide-react';

const DiscordIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 127.14 96.36"
    fill="currentColor"
    className={className}
  >
    <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1,105.25,105.25,0,0,0,32.19-16.14c2.64-27.38-4.51-51.11-19.32-72.1M42.56,65.36c-5.36,0-9.81-4.93-9.81-11s4.38-11,9.81-11,9.88,4.93,9.81,11S48,65.36,42.56,65.36Zm42.06,0c-5.36,0-9.81-4.93-9.81-11s4.38-11,9.81-11,9.88,4.93,9.81,11S90.06,65.36,84.62,65.36Z" />
  </svg>
);

const WhatsAppIcon = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const YouTubeIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const TelegramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.892-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

export default function FloatingSocial() {
  const { meta } = useI18n();
  const settings = meta?.settings || {};
  const [mobileOpen, setMobileOpen] = React.useState(false);
  
  const whatsappUrl = settings.social_whatsapp || 'https://api.whatsapp.com/send/?phone=905374630644';
  const whatsappChannel = settings.social_whatsapp_channel || 'https://whatsapp.com/channel/0029VaF5pWjGZNCnC43H342l';
  const discordUrl = settings.social_discord || 'https://discord.gg/h9xnRChVY8';
  const instagramUrl = settings.social_instagram || 'https://instagram.com/aegisstudios';
  const twitterUrl = settings.social_twitter || 'https://x.com/aegisstudios';
  const youtubeUrl = settings.social_youtube || 'https://youtube.com/@aegisstudios';
  const telegramUrl = settings.social_telegram || 'https://t.me/aegisstudios';

  const links = [
    { name: 'WhatsApp', icon: WhatsAppIcon, url: whatsappUrl, color: 'hover:border-green-500/50', bg: 'hover:bg-green-500/20', iconColor: 'group-hover:text-green-400' },
    { name: 'WhatsApp Kanalı', icon: WhatsAppIcon, url: whatsappChannel, color: 'hover:border-emerald-500/50', bg: 'hover:bg-emerald-500/20', iconColor: 'group-hover:text-emerald-400' },
    { name: 'Discord', icon: DiscordIcon, url: discordUrl, color: 'hover:border-[#5865F2]/50', bg: 'hover:bg-[#5865F2]/20', iconColor: 'group-hover:text-[#5865F2]' },
    { name: 'Instagram', icon: InstagramIcon, url: instagramUrl, color: 'hover:border-pink-500/50', bg: 'hover:bg-pink-500/20', iconColor: 'group-hover:text-pink-400' },
    { name: 'X (Twitter)', icon: XIcon, url: twitterUrl, color: 'hover:border-gray-300/50', bg: 'hover:bg-gray-300/20', iconColor: 'group-hover:text-gray-100' },
    { name: 'YouTube', icon: YouTubeIcon, url: youtubeUrl, color: 'hover:border-red-500/50', bg: 'hover:bg-red-500/20', iconColor: 'group-hover:text-red-500' },
    { name: 'Telegram', icon: TelegramIcon, url: telegramUrl, color: 'hover:border-blue-400/50', bg: 'hover:bg-blue-400/20', iconColor: 'group-hover:text-blue-400' },
  ].filter(l => l.url && l.url !== '#');

  if (links.length === 0) return null;

  return (
    <>
      {/* Desktop Floating Right Bar (hidden on mobile) */}
      <div className="hidden md:flex fixed top-1/2 -translate-y-1/2 right-0 z-[100] flex-col gap-2.5 py-4 px-2.5 bg-[#08080b]/80 backdrop-blur-xl border border-white/10 border-r-0 rounded-l-2xl shadow-[0_0_40px_rgba(0,0,0,0.8)]">
        {links.map((link) => (
          <a
            key={link.name}
            href={link.url}
            target="_blank"
            rel="noreferrer"
            className={`group relative flex items-center justify-center w-11 h-11 bg-white/5 rounded-xl border border-white/5 transition-all duration-300 ${link.bg} ${link.color}`}
          >
            <link.icon className={`w-5 h-5 text-white/70 transition-colors duration-300 ${link.iconColor}`} />
            
            {/* Tooltip */}
            <span className="absolute right-full mr-4 px-3 py-1.5 bg-[#1a1a24] text-white text-xs font-medium rounded-lg opacity-0 pointer-events-none group-hover:opacity-100 group-hover:mr-5 transition-all duration-300 whitespace-nowrap shadow-2xl border border-white/10">
              {link.name}
              <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 w-3 h-3 bg-[#1a1a24] border-t border-r border-white/10 rotate-45" />
            </span>
          </a>
        ))}
      </div>

      {/* Mobile Floating Speed-Dial Button (visible on mobile only) */}
      <div className="md:hidden fixed bottom-6 right-5 z-[100]">
        {/* Expanded Backdrop Overlay */}
        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[-1]"
            onClick={() => setMobileOpen(false)}
          />
        )}

        {/* Expanded Links List */}
        {mobileOpen && (
          <div className="flex flex-col gap-2.5 mb-3 items-end animate-in fade-in slide-in-from-bottom-5 duration-200">
            {links.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-[#0d0d15]/95 backdrop-blur-xl border border-white/15 text-white text-xs font-bold shadow-xl active:scale-95 transition-all ${link.bg}`}
              >
                <span>{link.name}</span>
                <div className="w-8 h-8 rounded-xl bg-white/10 flex items-center justify-center">
                  <link.icon className="w-4 h-4 text-[#f4d896]" />
                </div>
              </a>
            ))}
          </div>
        )}

        {/* Main Trigger Button */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[#f4d896] via-[#e4b44e] to-[#a97a1f] flex items-center justify-center text-[#17140b] shadow-[0_0_30px_rgba(244,216,150,0.5)] active:scale-90 transition-transform duration-200"
          aria-label="Sosyal Medya"
        >
          <div className="absolute inset-0 rounded-full animate-ping bg-[#f4d896]/30 pointer-events-none" />
          <MessageCircle className="w-6 h-6 stroke-[2.2]" />
        </button>
      </div>
    </>
  );
}
